import FeatureLayer from "@arcgis/core/layers/FeatureLayer";
import { useStore } from "../../stores/store";

const getSearchOptions = async (val, selectedTab) => {
  const getLayerById = useStore.getState().getLayerById;
  const field = selectedTab?.field;
  const outFields = selectedTab?.secondaryFields
    ? [field, ...selectedTab?.secondaryFields]
    : [field];
  const fuzzySearch = selectedTab?.fuzzySearch;
  const escapedSearchValue = val.replace(/'/g, "''");
  let where =
    escapedSearchValue !== ""
      ? `Upper(${field}) like '${
          fuzzySearch ? "%" : ""
        }${escapedSearchValue.toUpperCase()}%'`
      : "1=1";

  if (selectedTab?.getOptionsWhereClause) {
    where = selectedTab?.getOptionsWhereClause(val);
  }

  const q = {
    where,
    outFields,
    orderByFields: [field],
    num: 8,
    returnGeometry: false,
    returnDistinctValues: true,
  };
  let searchLayer;
  if (selectedTab?.layerId) {
    searchLayer = getLayerById(selectedTab?.layerId);
  } else {
    searchLayer = new FeatureLayer({ url: selectedTab?.queryUrl });
  }

  if (!searchLayer || !field) {
    return null;
  }
  const res = await searchLayer.queryFeatures(q);
  const _options = res.features.map((feature) => {
    return {
      value: selectedTab?.formatOptionValue
        ? selectedTab?.formatOptionValue(
            feature.attributes[field],
            escapedSearchValue
          )
        : feature.attributes[field],
      label: selectedTab?.formatOptionLabel
        ? selectedTab?.formatOptionLabel(
            feature.attributes[field],
            escapedSearchValue,
            feature.attributes
          )
        : feature.attributes[field],
    };
  });

  // Remove duplicate options
  const uniqueOptions = _options.filter(
    (v, i, a) => a.findIndex((t) => t.value === v.value) === i
  );

  return uniqueOptions;
};
export default getSearchOptions;
